import React from 'react';
import styled from 'styled-components/macro';
import Recommendation from './Recommendation';
import { RecommendationType } from '../types';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0;
`;

const Button = styled.button`
  height: 2rem;
  outline: none;
  border: none;
  background-color: rgb(31, 93, 234) !important;
  min-width: 10rem;
  margin: 0.2rem 0;
  color: white;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
`;

const CancelButton = styled(Button)`
  background-color: #d7205e !important;
`;

const AddButton = styled(Button)`
  background-color: transparent !important;
  border: 1px solid rgb(31, 93, 234);
  color: rgb(31, 93, 234) !important;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  height: 5rem;
  border-bottom: 1px solid #8d939d;
  align-items: flex-end;
  padding: 0.5rem 0;
`;

interface Props {
  push: (recommendation: any) => void;
  remove: (index: number) => void;
  values: RecommendationType[];
  setIsEditorOpen: (val: boolean) => void;
  errors?: any;
  touched?: any;
  questionsList: string[];
}

const newRecomendation = {
  title: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  shortDesc: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  longDesc: {
    en: '',
    de: '',
    fr: '',
    it: '',
  },
  visibleIfType: 'build',
  isActive: true,
};

const Recommendations = ({
  push,
  remove,
  setIsEditorOpen,
  values,
  errors,
  touched,
  questionsList,
}: Props) => {
  return (
    <Content>
      <Header>
        <ButtonWrapper>
          <Button type="submit">Save</Button>
          <CancelButton onClick={() => setIsEditorOpen(false)}>
            Close
          </CancelButton>
        </ButtonWrapper>
        <AddButton onClick={() => push(newRecomendation)} type="button">
          + Add Recommendation
        </AddButton>
      </Header>

      {values.map(
        ({ title, interpretations, visibleIfType, isActive }, index) => {
          const recomendationError = errors && errors[index];
          const recommendationTouched = touched && touched[index];

          return (
            <Recommendation
              key={index}
              index={index}
              remove={remove}
              title={title}
              errors={recomendationError}
              touched={recommendationTouched}
              interpretations={interpretations}
              visibleIfType={visibleIfType}
              questionsList={questionsList}
              isActive={isActive}
            />
          );
        }
      )}
    </Content>
  );
};

export default Recommendations;
